import React from 'react';

import { buildClassNames } from '../../utils';

export interface ContainerProps extends React.ComponentProps<'div'> {
  isActive?: boolean;
}

export const Container: React.FC<ContainerProps> = ({ className, isActive = false, ...props }) => {
  const baseClasses = isActive ? 'dropdown is-active' : 'dropdown';
  const classNames = buildClassNames(baseClasses, className);
  return <div className={classNames} {...props} />;
};
